module.exports = __webpack_public_path__ + "img/ios.d6b72576.png";